import React, { useEffect, useState } from 'react';
import './ShopSection.css';


import img1 from '../assets/banner.jpg';
import img2 from '../assets/banner2.jpg';
import img3 from '../assets/banner3.jpg';

const images = [img1, img2, img3];

const ShopSection = () => {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage(prev => (prev + 1) % images.length);
    }, 4000); 
    return () => clearInterval(interval);
  }, []);

  return (
    <section
      className="shop-section"
      style={{ backgroundImage: `url(${images[currentImage]})` }}
    >
      <div className="shop-overlay">
        <h2 className="shop-title">SHOP</h2>
        <a href="https://retroflexgym.com/" className="shop-button">VISITAR LOJA</a>
      </div>
    </section>
  );
};

export default ShopSection;
